import { devtools, subscribeWithSelector } from 'zustand/middleware'
import { DEVTOOLS_ENABLED } from '../consts'
import { create } from '../feat/appState/resetState'
import { createBookingSlice } from './bookingState/booking.context'
import { IBookingSlice } from './bookingState/booking.interfaces'
import { createMapSlice, MapSlice } from './map.slice'
import {
    createPageStateSlice,
    PageStateSlice,
} from './pageState/pageState.slice'

export interface EphemeralStore
    extends IBookingSlice,
        MapSlice,
        PageStateSlice {}

/**
 * A store that uses has no persistence.
 */
export const useEphemeralStore = create<EphemeralStore>()(
    subscribeWithSelector(
        devtools(
            (...a) => ({
                ...createBookingSlice(...a),
                ...createMapSlice(...a),
                ...createPageStateSlice(...a),
            }),
            { enabled: DEVTOOLS_ENABLED }
        )
    )
)

// alias for convenience
export const es = useEphemeralStore.getState
